import ForgotPassword from "../components/Login/ForgotPassword";
import background from "./background.jpg";

export default function ForgotPasswordPage() {
  return (
    <div style={{ backgroundImage: `url(${background})` }}>
      <ForgotPassword />
    </div>
  );
}
